import { Outlet, useLocation, useNavigate, } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import {
  editTicketsAction,
  editTicketsLoader,
  TicketEdit
} from "./ticket-search/TicketEdit";
import { TicketList, ticketsListLoader} from "./ticket-search/TicketList";
import { RFID } from "../../types/rfid";
import {TicketCompCreate, ticketCompCreateAction} from "./ticket-comp/TicketCompCreate";

const TicketsIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/tickets") {
    navigate(`/tickets/list`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export const ticketsRouter = {
  path: "/tickets",
  id: "tickets",
  element: <TicketsIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Tickets" href="/tickets/list" />,
  },
  children: [
    {
      path: "list",
      id: "tickets-list",
      element: <TicketList />,
      loader: ticketsListLoader,
    },
    {
      path: "ticket-comp",
      id: "ticket-comp",
      element: <TicketCompCreate />,
      action: ticketCompCreateAction,
    },
    {
      path: ":id/edit",
      id: "tickets-edit",
      element: <TicketEdit />,
      loader: editTicketsLoader,
      action: editTicketsAction,
      handle: {
        crumb: (data: { rfid: RFID }) => (
          <Breadcrumb
            name={`Edit ${data.rfid.uid}`}
            href={`/tickets/${data.rfid.id}/edit`}
          />
        ),
      },
    },
  ],
};
